// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.editUserRoot[data-v-07fee79c]\n{\n\tmargin: 10px;\n\tmin-width: 260px;\n}\n.title[data-v-07fee79c]\n{\n\tborder-bottom: 1px solid #000000;\n\tmargin-bottom: 10px;\n\tfont-size: 20px;\n}\n.deleteButtonRow[data-v-07fee79c],\n.loginHistoryButtonRow[data-v-07fee79c]\n{\n\tmargin-top: 20px;\n\tmargin-bottom: 20px;\n}\n.open_in_new[data-v-07fee79c]\n{\n\twidth: 16px;\n\theight: 16px;\n\tfill: currentColor;\n\tvertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
